import { Directive } from '@angular/core';

@Directive({
  selector: '[DashboardFilter]',
  exportAs: 'DashboardFilter',
})
export class DashboardFilterDirective {

  constructor() { }
  chart_details;

  ngOnInit() {

  }
  setChartDetails() {

  }

}
